<template>
  <v-dialog v-model="showModal" max-width="900px" persistent>    
    <v-card>      
        <v-toolbar dark class="primary">
          <v-btn icon @click.native="showModal = false" dark>
            <v-icon>fa-times</v-icon>
          </v-btn>
          <v-toolbar-title>{{title}}</v-toolbar-title>                    
        </v-toolbar>                 
        <v-card-text>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>          
        <v-form :class="visibility_class" @submit="handleSubmit">
          <v-tabs
            grow
            v-model="active_tab"                                        
            slider-color="primary"
          >
            <v-tab ripple key="0">Ogólne</v-tab>
            <v-tab ripple key="1">Dostęp do raportów</v-tab>
            <v-tab ripple key="2">Uprawnienia</v-tab>
            <v-tab-item key="0">
              <v-container  grid-list-xl>
                <v-layout row wrap>
                <v-flex xs12>
                <v-flex xs12>
                  <v-text-field label="Nazwa*" v-validate="'required'" name="name" id="name" :error-messages="errors.collect('name')" data-vv-as="Nazwa" v-model="name"></v-text-field>                 
                </v-flex>
                <v-flex xs12>
                  <v-text-field label="Opis" name="description" id="description"  v-model="description"></v-text-field>
                </v-flex>    
                <v-flex xs12 v-if="$can('do','POKO_SystemAdmin')">
                  <v-checkbox
                    v-model="is_super_admin_role"
                    name="isadmin"
                    id="isadmin"
                    label="Czy to rola widoczna tylko przez adminów?"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 >
                  <v-checkbox
                    v-model="is_static"
                    name="isstatic"
                    id="isstatic"
                    label="Czy ta rola jest nieusuwalna?"
                  ></v-checkbox>
                </v-flex>
                </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
            <v-tab-item key="1">
              <v-container  grid-list-xl>
                <v-layout row wrap>
                  <v-flex xs12 v-if="reportList != null && reportList.length > 0">
                      <h3>Dostępne raporty</h3>
                      <v-list>
                        <v-list-item v-for="rap in reportList" :key="rap.id">
                          <v-list-item-content>
                            {{rap.name}}
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-icon small @click="removeReport(rap.id)" title="Usuń raport">fa-trash-alt</v-icon>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-flex>
                    <v-flex xs12 v-if="availableRaports != null && availableRaports.length > 0">
                      <v-layout row wrap>
                        <v-flex xs8>
                          <v-select :items="availableRaports" label="Raport" placeholder="Wybierz raport..." v-model="selectedRaport" item-text="name" item-value="id">
                          </v-select>
                        </v-flex>           
                        <v-flex xs4>
                            <v-btn color="primary" @click="addRaport">Dodaj raport</v-btn>
                        </v-flex>            
                      </v-layout>
                    </v-flex>                  
                </v-layout>
              </v-container>              
            </v-tab-item>
            <v-tab-item key="2">
              <v-treeview :items="treeItems" v-model="selectedPermissions" selectable item-children="childrens" item-key="id" item-text="displayName"></v-treeview>
            </v-tab-item>
          </v-tabs>
        </v-form>
        </v-card-text>
        <v-card-actions>
           <v-spacer></v-spacer>
          <v-btn @click="closeForm" color="error">Zamknij</v-btn>
          <v-btn color="success" @click="handleSubmit">Zapisz</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { roleService } from "@/services/";
import { reportService } from "@/services/";
import swal from "sweetalert";
export default {
  name: "AddEditRole",
  data() {
    return {
      title: "Tworzenie nowej roli",
      loading: false,
      name: null,
      description: null,
      is_super_admin_role: false,
      is_static: false,
      visibility_class: "row",
      perms: [],
      selectedPermissions: [],
      treeItems: [],
      active_tab: 0,
      fetchedReports: null,
      selectedRaport: null,
      reportList: []
    };
  },
  props: ["id","visible"],
  methods: {
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    },
    closeForm() {
      this.$emit("close");
    },
    handleSubmit() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.saveRole();
        }
      });
    },
    removeReport(id){
      this.reportList = this.reportList.filter(
        x => x.id != id
      );
      //this.roles.push(role);
    },
    addRaport(){
      
      var rep = this.fetchedReports.find(x=>x.id == this.selectedRaport)
      if(rep != null)
      {
        this.reportList.push({id: rep.id, name: rep.name})
      }
      this.selectedRaport = null
    },
    saveRole() {
      var permsToSave = [];
      this.selectedPermissions.forEach(p => {
        var perm = this.perms.find(x=>x.id === p)
        if (perm) permsToSave.push(perm.name.replace("-", "."));
      });
      let reports = []
      this.reportList.forEach(x=> {
        reports.push(x.id)
      })
      this.loading = true;
      if (this.id === undefined || this.id == 0) {
        
        roleService
          .save({
            name: this.name,
            displayName: this.name,
            description: this.description,
            isSuperAdminRole: this.is_super_admin_role,
            isStatic: this.is_static,
            grantedPermissions: permsToSave,
            reports: reports
          })
          .then(() => {
            this.loading = false;
            this.$emit("close");
          })
          .catch(e => {
            this.showError(false, "Błąd zapisu roli.");
            console.log(e);
          });
      } else {
        roleService
          .updateRole({
            name: this.name,
            displayName: this.name,
            description: this.description,
            isSuperAdminRole: this.is_super_admin_role,
            isStatic: this.is_static,
            grantedPermissions: permsToSave,
            id: this.id,
            reports: reports
          })
          .then(() => {
            this.loading = false;
            this.$emit("close");
          })
          .catch(e => {
            console.log(e);
            this.showError(false, "Nie mozna zaktualizowac roli.");
          });
      }
    },
    clearFormData() {
        this.name = null
        this.description = null
        this.is_super_admin_role = false
        this.is_static = false
        this.reportList = []
        this.active_tab = 0
        this.selectedRaport = null
        this.selectedPermissions = []
        this.title= "Tworzenie nowej roli"
    },
    loadRoleData()
    {
      this.loading = true;
      
      roleService.get(this.id).then(resp => {
          if (resp.data != null && resp.data.success && resp.data.result.role != null) {
            let selectedPermissions = []
            this.name = resp.data.result.role.name;
            this.description = resp.data.result.role.description;
            this.is_super_admin_role = resp.data.result.role.isSuperAdminRole;
            this.is_static = resp.data.result.role.isStatic;
            this.title = "Edycja roli: " + this.name;
            resp.data.result.grantedPermissionNames.forEach(p => {
              var name = p.replace(".","-");
              var foundPerm = this.perms.find(x=> x.name == name);
              if(foundPerm != null)
              {
                selectedPermissions.push(foundPerm.id)
              }
              this.selectedPermissions = selectedPermissions
            });
            if(resp.data.result.grantedReports)
            {
              resp.data.result.grantedReports.forEach(r=> {
                let rep = this.fetchedReports.find(x=>x.id == r)
                if(rep && !this.reportList.find(x=> x.id === rep.id))
                {
                  this.reportList.push({id: rep.id, name: rep.name})
                }
              })
            }
            this.loading = false;    
          } else {
            throw "Error: " + resp.data.error;
          }
        }).catch(e => {
          console.log(e);
          this.showError(true, "Nie można pobrać informacji o roli.");
          this.loading = false;
        });
        
    }
  },
  created() {
    this.loading = true;

    roleService
        .getAllPermissions()
        .then(resp => {
            if (resp.data != null && resp.data.error == null) {
              let groups = []

              let itemId = 1
              let groupId = -1
                resp.data.result.forEach(p => {
                  if(!groups.find(x=>x.name === p.groupName)) {
                    groups.push({id: groupId, name: p.groupName,displayName:p.groupName, childrens: []})
                    groupId--
                  }
                  let grp = groups.find(x=>x.name === p.groupName)
                  grp.childrens.push({
                        id: itemId,
                        name: p.name.replace(".", "-"),
                        displayName: p.displayName,
                        active: false,
                        group: p.groupName
                    });
                    this.perms.push({id: itemId, name: p.name.replace(".", "-")})
                    itemId++
                });
              this.treeItems = groups
                reportService.getAll().then(resp => {
                      if(resp.data != null && resp.data.result != null){
                        this.fetchedReports = resp.data.result        
                        if (this.id !== undefined && this.id > 0) {
                          this.loadRoleData();
                        }
                      }
                }).catch(() => {
                    this.showError(true, "Nie można pobrać listy raportów");
                });
                
            } else {
                throw "Error";
            }
            this.loading = false;
        })
        .catch(e => {
            console.log(e);
            this.showError(true, "Nie można pobrać listy uprawnień.");
        });
  },
  components: {
  },  
  computed: {
    availableRaports: function() {            
        if(this.reportList && this.fetchedReports)
        {
          return this.fetchedReports.filter(x=> !this.reportList.find(z=> z.id == x.id))
        }        
        return this.fetchedReports
    },
    showModal: {
      get: function() {
        if(!this.visible)
        {
          this.clearFormData()
          this.errors.clear();
        }
        return this.visible
      },
      set: function(value) {                
        if(!value){
          this.$emit('close')
        }

      }
    }
  },  
  watch: {
    id: function(newId)
    {

      if(newId > 0)
      {
        this.loading = true
        this.loadRoleData()
      }
      else
      {
          this.clearFormData()
          this.errors.clear();
      }

    }
  }  
};
</script>

<style>
  .priv-list .v-list__tile
  {
    height: auto !important;
    margin-top: 3px !important;
  }
</style>
